import { createStyles, makeStyles } from '@material-ui/core'

export const useLayoutPlugStyles = makeStyles((theme) =>
  createStyles({
    root: {},

    content: {
      maxWidth: 1556,
      margin: '94px auto 0',
      display: 'flex',
      gap: 82,
      alignItems: 'center',
      '@media (max-width: 1400px)': {
        flexDirection: 'column-reverse',
        padding: '0 67px'
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: 100,
        gap: 70
      },
      [theme.breakpoints.down('xs')]: {
        padding: '0 40px',
        gap: 20,
        marginTop: 50
      }
    },

    plugImg: {
      width: 658,
      height: 654,
      [theme.breakpoints.down('sm')]: {
        width: 424,
        height: 395
      },
      [theme.breakpoints.down('xs')]: {
        width: 300,
        height: 300
      }
    },

    contentLeft: {
      paddingTop: 70,
      [theme.breakpoints.down('sm')]: {
        padding: 0
      }
    },

    title: {
      fontSize: 45,
      fontWeight: 500,
      fontFamily: 'Montserrat',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        fontSize: 24
      },
      [theme.breakpoints.down('xs')]: {
        lineHeight: '30px'
      }
    },

    subtitle: {
      marginTop: 20,
      fontSize: 22,
      fontFamily: 'Montserrat',
      fontWeight: 500,
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        fontSize: 18
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 15,
        lineHeight: '18px'
      }
    },

    contentRight: {}
  })
)
